import { MutationTree } from 'vuex'
import { RootState } from '../types'
import setPlatform from './setPlatform'
import setOnline from './setOnline'

const mutations: MutationTree<RootState> = { setPlatform, setOnline }

export default mutations
